import React, { useState } from "react";
import {  toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Main from "./Main";
import AppBreadcrumbs from "../components/ui/AppBreadcrumbs";
const Broadband = () => {
  const [operator, setOperator] = useState("");
  const handleBlur = () => {
    if (!operator.trim()) {
      toast.error("Please enter operator name", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }
    toast.success("Broadband details fetched successfully!", {
      position: "top-center",
      autoClose: 2000,
    });
  };
  return (
    <Main showInfoText={false} showRightPanel={false}>
      <AppBreadcrumbs
        items={[
          { label: "Dashboard", to: "/" },
          { label: "Recharge & Bills -1" },
          { label: "Broadband Bill" },
        ]}
      />
      <div className="flex flex-col lg:flex-row flex-1 mt-4">
        <div className="flex-1 flex flex-col items-start">
          <div className="ds-card p-4 sm:p-6 w-full max-w-[230px] lg:max-w-[260px]">
            <h2 className="text-[14px] font-semibold text-[var(--text-dark)] mb-4 text-center sm:text-left">
              Broadband Bill
            </h2>
            <div>
              <label className="ds-label">
                Operator Name <span className="text-[var(--error-color)]">*</span>
              </label>
              <input
                type="text"
                value={operator}
                onChange={(e) => setOperator(e.target.value)}
                onBlur={handleBlur}
                placeholder="Select Your Broadband Provider"
                className="ds-input text-[13px]"
              />
            </div>
          </div>
        </div>
      </div>
    </Main>
  );
};
export default Broadband;
